import {
	SectionContent,
	SectionWrapper
} from "../HomePageStyles";
import {GenericSectionLayout} from "../Layouts/GenericSection/GenericSectionLayout";
import * as React from "react";

export const generateGenericSections = (sections: any[]) => {
	const returnValue = sections.map((section: any) => {
		const outgoingProps = {
			section
		}
		const innerReturnValue = (
			<SectionWrapper>
				<SectionContent>
					<GenericSectionLayout {...outgoingProps} />
				</SectionContent>
			</SectionWrapper>
		);
		return innerReturnValue;
	})
	return returnValue;
}
